import { render, staticRenderFns } from "./BuscadorFormularioContacto.vue?vue&type=template&id=0015acd3&"
import script from "./BuscadorFormularioContacto.vue?vue&type=script&lang=js&"
export * from "./BuscadorFormularioContacto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports